import { types } from "../action-types";

const initialState = {
  loading: false,
  success: false,
  error: false,
  bidData: {},
};

const createBidReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_BID_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      };

    case types.CREATE_BID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        bidData: action.payload,
      };
    case types.CREATE_BID_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
      case types.CLEAR_BID_SUCCESS:
        return {
          loading: false,
          success: false,
          error: false,
          // initialState
        };

    case types.CREATE_MULTI_BID_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      };

    case types.CREATE_MULTI_BID_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        bidData: action.payload
      };

    case types.CREATE_MULTI_BID_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };

    default:
      return state;
  }
};
export default createBidReducers;
